import { render } from "./prescription.vue?vue&type=template&id=8607610e&scoped=true"
import script from "./prescription.vue?vue&type=script&lang=js"
export * from "./prescription.vue?vue&type=script&lang=js"

import "./prescription.vue?vue&type=style&index=0&id=8607610e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8607610e"]])

export default __exports__